<script lang="ts" setup>
import type { PaidInvoiceTableInvoice } from './types';

const props = defineProps<{
  row: PaidInvoiceTableInvoice;
  column: string;
  value: unknown;
  isSelected: boolean;
}>();

const emit = defineEmits<{
  (e: 'toggle-selection'): void;
  (e: 'navigate-to-invoice'): void;
}>();
</script>

<template>
  <div v-if="props.column === '_actions'" class="actions-cell">
    <input
      type="checkbox"
      class="selection-checkbox"
      :checked="props.isSelected"
      @click.stop
      @change.stop="emit('toggle-selection')"
    />
  </div>
  <span
    v-else-if="props.column === 'status'"
    class="status-badge"
    :class="props.row.status"
    >{{ props.value }}</span
  >
  <template v-else>{{ props.value }}</template>
</template>

<style scoped lang="scss">
.actions-cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.selection-checkbox {
  cursor: pointer;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-left: 11px;
}

.btn-go-to-invoice {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  line-height: 0;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.15);
  }
}

.status-badge {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 9999px;
  font-size: 0.85em;
  font-weight: 700;

  &.incoming {
    background-color: #90caf9;
  }
  &.undercertificate {
    background-color: var(--invoice-undercertificate);
  }
  &.parked {
    background-color: var(--invoice-parked);
  }
  &.disputed {
    background-color: var(--invoice-disputed);
  }
  &.voided {
    background-color: var(--invoice-voided);
  }
  &.approved {
    background-color: var(--invoice-approved);
  }
  &.paid {
    background-color: var(--invoice-paid);
  }
  &.verified-debt {
    background-color: var(--invoice-verified-debt);
  }
}
</style>
